var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'indented-body': _vm.indent, 'unindented-body': !_vm.indent }},[_c('h3',{staticClass:"title is-3 mt-5 mb-3"},[_vm._v("\n    "+_vm._s(_vm.caption)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }